import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'app-dialog-field-options-manager-editor',
  templateUrl: './dialog-field-options-manager-editor.component.html',
  styleUrls: ['./dialog-field-options-manager-editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogFieldOptionsManagerEditorComponent extends DialogDefinitionEditorBase implements OnInit {

  isAddOptionDisabled = false;

  isOptionEditing: boolean;
  editingOption: any;
  exitingText: any;
  optionIsEditingState: any = {};
  optionIdIsEditingState: any = {0:0,1:0,2:0};
  translationIsEditingState: any = {};
  options = [];
  addButtonTitle = "Add Option";

  constructor(private snackBarService: SnackBarService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.dynamicFormControl.value) {
      this.options = this.dynamicFormControl.value;
    }
    if (this.dialogField.title) {
      this.addButtonTitle = this.dialogField.title;
    }
  }


  startEditItem(option) {
    if (!option.isCustom) {
      this.snackBarService.showError('Default options cannot be edited.');
      return;
    }
    console.log(option);
    this.isOptionEditing = false;
    if (this.editingOption) {
      this.optionIsEditingState[this.editingOption.id] = false;
    }
    this.editingOption = option;
    this.optionIsEditingState[this.editingOption.id] = true;
    this.exitingText = option.text;
  }

  removeOption(optionToRemove) {
    this.options = this.dynamicFormControl.value;
    this.options = this.options.filter(option => option.id !== optionToRemove.id);
    let order = 0;
    this.options.forEach(option => option.order = order++);
    this.dynamicFormControl.setValue(this.options);
  }

  moveOption(optionToMove, index, direction) {
    this.options = this.dynamicFormControl.value;
    console.log('move:', optionToMove, index, direction);
    switch (direction) {
      case 'up':
        if(index>0) {
          // tslint:disable-next-line:max-line-length
          [this.options[index], this.options[index - 1]] = [this.options[index - 1], this.options[index]];
          this.options[index].order = index;
          this.options[index - 1].order = index - 1;
        }
        break;
      case 'down':
        if(index < this.options.length - 1) {
          // tslint:disable-next-line:max-line-length
          [this.options[index], this.options[index + 1]] = [this.options[index + 1], this.options[index]];
          this.options[index].order = index;
          this.options[index + 1].order = index + 1;
        }
        break;
    }
  }

  resetOptionEditing() {
    this.isOptionEditing = false;
    if (this.editingOption) {
      this.optionIsEditingState[this.editingOption.id] = false;
    }
    this.editingOption = null;
    this.exitingText = '';
  }



  onSaveOption(event) {
    let isTitleExist = false;
    this.options = this.dynamicFormControl.value;
    if (!this.options) {
      this.options = [];
    }

    this.options.forEach(option => {
      if (option.text === event.text) {
        if (this.editingOption) {
          if (option.id === this.editingOption.id) {
            return;
          }
        }
        isTitleExist = true;
        return;
      }
    });
    if (isTitleExist) {
      this.snackBarService.showError('Option with same title already exist. Please choose a different title.');
      return;
    }
    if (this.editingOption) {
      this.editingOption.text = event.text;
    } else {
      const option = {
        'id': event.text, // To use in list cell editor since it used value
        'text': event.text,
        'order': this.options.length,
        'isCustom': true,
        'metaData': {
          'Text': event.text,
          'TranslatedText': ''
        }
      };
      this.optionIsEditingState[option.id] = false;
      this.options.push(option);
    }
    this.dynamicFormControl.setValue(this.options);
    this.resetOptionEditing();
  }
  addOption() {
    this.resetOptionEditing();
    this.isOptionEditing = true;
    if (this.editingOption) {
      this.optionIsEditingState[this.editingOption.id] = false;
    }
  }

  editOptionId(i) {
    this.resetTranslationState(i);
    this.optionIdIsEditingState[i] = true;
  }

  editOptionIdDone(i: any) {
    this.resetOptionIdEditing(i);
  }

  getTranslationFromOption(option: any): string {
    return option.metaData?.TranslatedText ?? option.translation ?? '';
  }

  updateTranslationInOption(option: any, translation: string): void {
    if (!option.metaData) {
      option.metaData = {};
    }
    option.metaData.TranslatedText = translation.trim();
  }

  editTranslation(index: number, option: any) {
    this.resetOptionIdEditing(index);
    this.translationIsEditingState[index] = true;
  }

  editTranslationDone(index: number) {
    if (this.options[index]) {
      const translation = this.getTranslationFromOption(this.options[index]);
      this.updateTranslationInOption(this.options[index], translation);
      this.dynamicFormControl.setValue([...this.options]);
    }
    this.translationIsEditingState[index] = false;
  }

  private resetOptionIdEditing(index: number) {
    if (this.optionIdIsEditingState[index]) {
      this.optionIdIsEditingState[index] = false;
    }
  }

  private resetTranslationState(index: number) {
    if (this.translationIsEditingState[index]) {
      this.translationIsEditingState[index] = false;
    }
  }
}
